import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, userManager } from 'store';
import { User } from 'oidc-client';
import { action as appInitAction } from 'store/accountReducer';
import CallbackHandler from './CallbackHandler';
import UserService from 'services/UserService';
import { Backdrop, Box, Grid, Typography, useTheme } from '@mui/material';
import Logo from 'ui-component/Logo';
import { useNavigate } from 'react-router-dom';
import PoweredBy from 'ui-component/PoweredBy';

const AuthLogin = (): ReactElement => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isLoadingUser = useSelector<AppState, boolean>((state) => state.oidc.isLoadingUser);
    const user = useSelector<AppState, User>((state) => state.oidc.user);
    const location = useSelector<AppState, any>(
        (state) => state.router.location,
        (left, right) => JSON.stringify(left) === JSON.stringify(right)
    );

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const url = location.pathname.substring(0, 9);
    const isCallbackUrl = url === '/callback';
    // const [isInMaintenance, setIsInMaintenance] = useState<boolean>(false);

    const showBackdrop: boolean = !user || isLoadingUser || isLoading;

    const userService = new UserService();

    useEffect(() => {
        (async () => {
            if (user) {
                try {
                    setIsLoading(true);
                    const userInfo = await userService.getUserInfo(user);
                    if (userInfo) {
                        dispatch(appInitAction.setUserInfo(userInfo));
                        dispatch(appInitAction.setIsOfflineConfigInitialized(true));
                        dispatch(appInitAction.setIsInitialized(true));
                    } else navigate('/error');
                    setIsLoading(false);
                } catch (error) {
                    setIsLoading(false);
                    dispatch(appInitAction.setInitializationError(true));
                }
            }
        })();
    }, [user, dispatch]);

    useEffect(() => {
        if (!user && !isLoadingUser && !isCallbackUrl) {
            userManager.signinRedirect({
                data: { path: location.pathname }
            });
        }
    }, [user, isLoadingUser, isCallbackUrl, location.pathname]);

    // if (isInMaintenance) {
    //     return <></>;
    // }

    return (
        <Backdrop
            open={showBackdrop}
            sx={{
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.common.white,
                height: '100vh',
                position: 'relative'
            }}
        >
            <Logo sx={{ width: '500px', height: '100px' }} />
            <PoweredBy sx={{ '& img': { width: '200px', aspectRatio: '10 / 2' } }} />

            <CallbackHandler />
        </Backdrop>
        // <Box
        //     sx={{
        //         alignItems: 'center',
        //         backgroundColor: '#0B2D42',
        //         display: 'flex',
        //         flexDirection: 'column',
        //         height: '100%',
        //         justifyContent: 'center',
        //         left: 0,
        //         p: 3,
        //         position: 'fixed',
        //         top: 0,
        //         width: '100%',
        //         zIndex: 2000
        //     }}
        // >
        //     <CallbackHandler />
        //     <img alt="logoInspection" src="" style={{ height: '75px', width: 'auto', paddingTop: '10px' }} />
        //     <Typography color="textSecondary" variant="h5" align="center">
        //         Web Portal
        //     </Typography>
        //     <div
        //         style={{
        //             flexGrow: 2,
        //             display: 'flex',
        //             flexDirection: 'column',
        //             justifyContent: 'flex-end',
        //             color: 'rgb(145, 158, 171)',
        //             width: 300
        //         }}
        //     >
        //         <LinearProgress color="primary" variant="indeterminate" />
        //     </div>
        //     <div style={{ color: 'rgb(145, 158, 171)' }}>{/* <InitStatus /> */}</div>
        //     <div
        //         style={{
        //             flexGrow: 2,
        //             display: 'flex',
        //             flexDirection: 'column',
        //             justifyContent: 'flex-end',
        //             alignItems: 'center',
        //             marginBottom: '50px'
        //         }}
        //     >
        //         <Typography color="textSecondary" variant="subtitle1">
        //             Powered by
        //         </Typography>
        //         <img alt="logoCompanyOrangedev" src="" style={{ width: '180px', marginTop: '20px', marginBottom: '20px' }} />
        //     </div>
        // </Box>
    );
};

export default AuthLogin;
